// extracted by mini-css-extract-plugin
export default {"questionVoteBox":"U3-z","upvote":"V3-z","downvote":"W3-z","numVotes":"X3-z","votesDescription":"Y3-z","report":"Z3-z","voted":"_3-z","answerVoteBox":"a4-z","justReported":"b4-z"};